import {
  updateLocalPreferences,
  saveTablePreferences,
} from "../../../redux/tablePreferenceSlice";

/**
 * Reorders columns in the table by moving a column from startIndex to endIndex
 * @param {Array} columns - Current columns array
 * @param {number} startIndex - Starting index of the column to move
 * @param {number} endIndex - Ending index where the column should be moved
 * @param {Function} dispatch - Redux dispatch function
 * @param {string} tableId - The table identifier
 */
export const reorderColumnsUtil = (
  columns,
  startIndex,
  endIndex,
  dispatch,
  tableId
) => {
  const updated = Array.from(columns);
  const [removed] = updated.splice(startIndex, 1);
  updated.splice(endIndex, 0, removed);
  dispatch(updateLocalPreferences({ tableId, preferences: updated }));
  dispatch(saveTablePreferences({ tableId, preferences: updated }));
};

/**
 * Toggles the visibility of a column
 * @param {string} columnId - The ID of the column to toggle
 * @param {Array} columns - Current columns array
 * @param {Function} dispatch - Redux dispatch function
 * @param {string} tableId - The table identifier
 */
export const toggleColumnVisibilityUtil = (
  columnId,
  columns,
  dispatch,
  tableId
) => {
  const updated = columns.map((c) =>
    c.id === columnId ? { ...c, visible: !c.visible } : c
  );
  dispatch(updateLocalPreferences({ tableId, preferences: updated }));
  dispatch(saveTablePreferences({ tableId, preferences: updated }));
};

/**
 * Resets table columns to default configuration
 * @param {Array} defaultColumns - The default columns configuration
 * @param {Function} dispatch - Redux dispatch function
 * @param {string} tableId - The table identifier
 */
export const resetToDefaultUtil = (defaultColumns, dispatch, tableId) => {
  dispatch(
    updateLocalPreferences({ tableId, preferences: defaultColumns })
  );
  dispatch(
    saveTablePreferences({ tableId, preferences: defaultColumns })
  );
};
